import { FilterMatchMode } from "primeng/api"

const matter = {
  statuses: [
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Active', value: 'Active' },
  ]
}

const organization = {
  statuses: [
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Active', value: 'Active' },
  ]
}

const project = {
  isEnforceEstimatedTimeList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ],
  isBillableList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ],
  serviceTypes: [
    { label: 'Managed', value: 'Managed' },
    { label: 'Transactional', value: 'Transactional' },
  ],
  priorities: [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
  ],
  statuses: [
    { label: 'In Progress', value: 'In Progress' },
    { label: 'Pending Payment', value: 'Pending Payment' },
    // { label: 'Submitted to Billing', value: 'Submitted to Billing' },
    { label: 'On Hold', value: 'On Hold' },
    { label: 'Completed', value: 'Completed' },
    { label: 'Rejected', value: 'Rejected' },
  ],
  filters:[
    { label: 'My Projects', value: 'My Projects' },
    { label: 'All Projects', value: 'All Projects' },
  ]
}

const task = {
  statuses: [
    { label: 'Open', value: 'Open' },
    { label: 'Assigned', value: 'Assigned' },
    { label: 'Accepted', value: 'Accepted' },
    { label: 'Ready to Complete', value: 'Ready to Complete' },
    { label: 'For Approval', value: 'For Approval' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Completed', value: 'Completed' }
  ],
  gridFilterStatus: ['Open','Assigned', 'Approved','Accepted' ,'For Approval'
  ],
  assignmentStatuses: [
    { label: 'Assigned', value: 'Assigned' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Accepted', value: 'Accepted' },
    // { label: 'Rejected', value: 'Rejected' },
  ],
  reviewstatuslist:
  [
  { label: 'Waiting on Client', value: 'Waiting on Client' } ,
  { label: 'Waiting on Agency', value: 'Waiting on Agency' } ,
  { label: 'Waiting on Payment', value: 'Waiting on Payment' } ,
  { label: 'Waiting on SOS', value: 'Waiting on SOS' } 
  ],
  reassignReasonList:[
    { "label": "Poor Quality", value: "Poor Quality" },
    { "label": "Unresponsive", value: "Unresponsive" },
    { "label": "Monitoring Task", value: "Monitoring Task" },
    { "label": "TK Out", value: "TK Out" },
    { "label": "Misassigned", value: "Misassigned" },
    { "label": "Task Modifications", value: "Task Modifications" },
    { "label": "Task Paused", value: "Task Paused" },
    { "label": "At Risk", value: "At Risk" },
  ],
  deleteReasonList:[
    // { "label": "Quality", value: "Quality" },
    // { "label": "Unresponsive", value: "Unresponsive" },
    // { "label": "Risk", value: "Risk" },
    { label: 'Poor Quality', value: 'Poor Quality' },
    { label: 'Excessive Time', value: 'Excessive Time' },
    { label: 'Poor Description', value: 'Poor Description' },
    { label: 'Clerical Error', value: 'Clerical Error' },
  ],
  descriptionTypes: [
    { label: 'Free', value: 'Free' },
    { label: 'Auto', value: 'Auto' }
  ],
  approvalRequiredList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  isRejectedFilter: [
    { label: 'Yes', value: 'Yes' },
    // { label: 'No', value: 'No' }
  ],
  filters:[
    { label: 'All Tasks', value: 'All Tasks' },
    { label: 'My Tasks', value: 'My Tasks' },
    { label: 'My Approval Tasks', value: 'My Approval Tasks' },
    { label: 'Past Dues', value: 'Past Dues' },
    { label: 'Billing Closeouts', value: 'Billing Closeouts', roles: ['LPC', 'ADMIN'] },
  ],
  rateTypes: [
    { label: 'Fixed Rate', value: 'Fixed Rate' },
    { label: 'Hourly', value: 'Hourly' }
  ],
  dueDaySlots: [
    { label: 'Morning', value: 'Morning' },
    { label: 'Afternoon', value: 'Afternoon' },
    { label: 'Evening', value: 'Evening' }
  ],
  stateCodeMapList: [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'BI', label: 'Baker Island' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'GU', label: 'Guam' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'HW', label: 'Howland Island' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'JQ', label: 'Jarvis Island' },
    { value: 'JK', label: 'Johnston Atoll' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'KM', label: 'Kingman Reef' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MW', label: 'Midway Atoll' }, // Midway Islands
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NA', label: 'Navassa Island' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PL', label: 'Palmyra Atoll' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'VI', label: 'United States Virgin Islands' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WK', label: 'Wake Island' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ],
  canadaStateList :[
    { value: 'AB', label: 'Alberta' },
    { value: 'BC', label: 'British Columbia' },
    { value: 'MB', label: 'Manitoba' },
    { value: 'NB', label: 'New Brunswick' },
    { value: 'NL', label: 'Newfoundland and Labrador' },
    { value: 'NT', label: 'Northwest Territories' },
    { value: 'NS', label: 'Nova Scotia' },
    { value: 'NU', label: 'Nunavut' },
    { value: 'ON', label: 'Ontario' },
    { value: 'PE', label: 'Prince Edward Island' },
    { value: 'QC', label: 'Quebec' },
    { value: 'SK', label: 'Saskatchewan' },
    { value: 'YT', label: 'Yukon' }
  ],
  countryList : ["United States","Canada", "Afghanistan", "Aland Islands", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon",  "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Cook Islands", "Costa Rica", "Cote D'Ivoire (Ivory Coast)", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji Islands", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia The", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey and Alderney", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Honduras", "Hong Kong S.A.R.", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau S.A.R.", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Man (Isle of)", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Korea", "North Macedonia", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn Island", "Poland", "Portugal", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Saint-Barthelemy", "Saint-Martin (French part)", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen Islands", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "The Bahamas", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",  "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City State (Holy See)", "Venezuela", "Vietnam", "Virgin Islands (British)", "Virgin Islands (US)", "Wallis and Futuna Islands", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"] 
}
//, "Puerto Rico", "American Samoa"

const timeRecord = {
  taskStatusList: [
    { label: 'Approved', value: 'Approved' },
    { label: 'Accepted', value: 'Accepted' },
    // { label: 'Rejected', value: 'Rejected' },
    { label: 'For Approval', value: 'For Approval' },
    { label: 'Ready to Complete', value: 'Ready to Complete' }

  ],
  timeRecStatusList: [
    { label: 'In Progress', value: 'In Progress' },
    // { label: 'Assigned', value: 'Assigned' },
    { label: 'Approved', value: 'Approved' },
    // { label: 'Accepted', value: 'Accepted' },
    { label: 'Rejected', value: 'Rejected' },
    { label: 'In Review', value: 'In Review' },
  ],
  billableList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  filters:[
    { label: 'My Time Records', value: 'My Time Records' },
    { label: 'All Time Records', value: 'All Time Records' },
    { label: 'My Approval TimeRecords', value: 'My Approval TimeRecords' }],
  rejectStandardReasonList:[
    // { label: 'Not Available', value: 'Not Available' },
    // { label: 'Lack Experience', value: 'Lack Experience' },
    // { label: 'Task Update Needed', value: 'Task Update Needed' }
    { label: 'Poor Quality', value: 'Poor Quality' },
    { label: 'Excessive Time', value: 'Excessive Time' },
    { label: 'Poor Description', value: 'Poor Description' },
    { label: 'Clerical Error', value: 'Clerical Error' },
   
  ],
  stateCodeMapList:[
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AS', label: 'American Samoa' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'BI', label: 'Baker Island' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'GU', label: 'Guam' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'HW', label: 'Howland Island' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'JQ', label: 'Jarvis Island' },
    { value: 'JK', label: 'Johnston Atoll' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'KM', label: 'Kingman Reef' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MW', label: 'Midway Atoll' }, // Midway Islands
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NA', label: 'Navassa Island' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'MP', label: 'Northern Mariana Islands' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PL', label: 'Palmyra Atoll' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'PR', label: 'Puerto Rico' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UM', label: 'United States Minor Outlying Islands' },
    { value: 'VI', label: 'United States Virgin Islands' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WK', label: 'Wake Island' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
  ]
}

const taskCatalog = {
  descriptionTypesList: [
    { label: 'Free', value: 'Free' },
    { label: 'Auto', value: 'Auto' }
  ],
  billableList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  stateRelatedList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  reqEstimateList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  readyStateList: [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' }
  ],
  rateTypesList: [
    { label: 'Fixed Rate', value: 'Fixed Rate' },
    { label: 'Hourly', value: 'Hourly' }
  ],
}

const importData = {
  statusList: [
    { label: 'SUCCESS', value: 'SUCCESS' },
    { label: 'FAILED', value: 'FAILED' }
  ]
}

const projectTemplateList={
  statusList: [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
  ]
}

const matchModeOptionsDateList = [
  { label: 'Date Is', value: FilterMatchMode.DATE_IS },
  { label: 'Date Before', value: FilterMatchMode.DATE_BEFORE },
  { label: 'Date After', value: FilterMatchMode.DATE_AFTER },
  // { label: 'Date Between', value: FilterMatchMode.BETWEEN },
];
export { matter, organization, project, task, timeRecord, taskCatalog, importData, matchModeOptionsDateList,projectTemplateList }
